import React from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { FaEye, FaEdit } from 'react-icons/fa';

const ContractsTable = ({ currentContracts, statusColors, setSelectedContract, toggleModal, isAdmin }) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              {[
                "Contract Number",
                "Category",
                "Parties",
                "Description",
                "Start Date",
                "End Date",
                "Status",
                "Actions",
              ].map((header) => (
                <th
                  key={header}
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            <AnimatePresence>
              {currentContracts.map((contract) => (
                <motion.tr
                  key={contract._id}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="hover:bg-gray-50 transition duration-300"
                >
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {contract["Contract Number"]}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {contract.category}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {contract.Parties}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500 max-w-xs">
                    <div className="group relative">
                      <p className="truncate max-w-[200px]">
                        {contract["Contract Description"]}
                      </p>
                      {contract["Contract Description"].length > 100 && (
                        <div className="hidden group-hover:block absolute z-10 bg-white border border-gray-200 rounded-md p-2 shadow-lg max-w-md left-0">
                          {contract["Contract Description"]}
                        </div>
                      )}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {new Date(contract.startDate).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {new Date(contract.endDate).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`px-2 py-1 text-xs font-semibold rounded-full ${
                        statusColors[contract.status]
                      }`}
                    >
                      {contract.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <button
                      onClick={() => setSelectedContract(contract)}
                      className="text-indigo-600 hover:text-indigo-900 mr-3 transition duration-300"
                      title="View"
                    >
                      <FaEye />
                    </button>
                    {isAdmin && (
                      <button
                        onClick={() => toggleModal(contract)}
                        className="text-emerald-600 hover:text-emerald-900 transition duration-300"
                        title="Manage"
                      >
                        <FaEdit />
                      </button>
                    )}
                  </td>
                </motion.tr>
              ))}
            </AnimatePresence>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContractsTable;